import { yellow } from "@mui/material/colors";
import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { TimelineMinWidth } from "assets/jss/common-styles";
import { InputAutoCompleteStyles } from "assets/jss/mui-extras/inputAutoCompleteStyle";

export default (theme: Theme) => createStyles({
    ...InputAutoCompleteStyles(theme),

    dialogContent: {
        paddingTop: "0 !important",
        display: "flex"
    },

    inputBlock: {
        marginBottom: theme.spacing(2)
    },


    container: {
        width: "100%",
        minWidth: TimelineMinWidth,
        minHeight: "300px",
    },

    containerFlex: {
        display: "flex",
        flexDirection: "column",
    },

    containerData: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.grey[200],
        marginBottom: "4px",
        padding: "4px",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto"
    },

    "containerData_input": {
        marginBottom: "10px",
        border: "none",
        borderWidth: 1,
        borderBottomWidth: 1,
        borderBottomStyle: "dashed",
        borderBottomColor: theme.palette.grey[200],

        "& > input": {
            border: "none",
            fontSize: theme.typography.h5.fontSize,
            color: theme.typography.h5.color,
            padding: "10px",
            width: "100%",
            backgroundColor: "transparent",
            "&:focus": {
                outline: "none"
            }
        }
    },

    "containerData_textarea": {
        marginBottom: "10px",
        border: "none",
        borderBottomWidth: 1,
        borderBottomStyle: "dashed",
        borderBottomColor: theme.palette.grey[200],
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto",
        "& > textarea": {
            border: "none",
            width: "100%",
            backgroundColor: "transparent",
            resize: "none",
            "&:focus": {
                outline: "none"
            }
        },
        "& .quill-region .ql-container": {
            borderRadius: 0,
        },
    },

    suggestionContainer: {
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        "& ul li": {
            padding: 0,
        }
    },

    fieldError: {
        borderBottomColor: theme.palette.error.main,
        borderBottomWidth: 1,
        borderBottomStyle: "solid"
    },

    footerMessage: {
        width: "100%",
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.grey[500]
    },

    actions: {
        width: "100%"
    },

    avatarLarge: {
        width: 89,
        height: 89,
    },

    highlightBox: {
        backgroundColor: yellow["200"],
        padding: "10px",

        "& td": {
            borderBottom: "none"
        }
    }

});
